import { ChevronLeft, ChevronRight } from "lucide-react";

const MESES = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
const DOW = ["D", "S", "T", "Q", "Q", "S", "S"];

const STATE_CLS = {
  livre: "bg-emerald-400/15 text-emerald-300 hover:bg-emerald-400/25 cursor-pointer",
  ocupado: "bg-amber-400/15 text-amber-300 hover:bg-amber-400/25 cursor-pointer",
  bloqueado: "bg-zinc-700/60 text-zinc-500 line-through cursor-not-allowed",
  vazio: "text-zinc-600 cursor-not-allowed",
};

export function MonthCalendar({ ano, mes, onNavigate, dayState, onSelect, selected }) {
  const first = new Date(ano, mes, 1);
  const startDay = first.getDay();
  const daysInMonth = new Date(ano, mes + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const dateStr = (d) => `${ano}-${String(mes + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

  return (
    <div data-testid="month-calendar">
      <div className="flex items-center justify-between mb-2">
        <button type="button" data-testid="cal-prev" onClick={() => onNavigate(-1)}
          className="h-7 w-7 flex items-center justify-center rounded-md text-zinc-400 hover:bg-zinc-800 hover:text-zinc-100 transition-colors duration-200">
          <ChevronLeft className="h-4 w-4" />
        </button>
        <p className="text-sm font-medium text-zinc-100" data-testid="cal-title">{MESES[mes]} {ano}</p>
        <button type="button" data-testid="cal-next" onClick={() => onNavigate(1)}
          className="h-7 w-7 flex items-center justify-center rounded-md text-zinc-400 hover:bg-zinc-800 hover:text-zinc-100 transition-colors duration-200">
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center">
        {DOW.map((d, i) => <span key={i} className="text-[10px] text-zinc-500 font-medium py-1">{d}</span>)}
        {cells.map((d, i) => {
          if (!d) return <span key={`e${i}`} />;
          const ds = dateStr(d);
          const state = dayState ? dayState(ds) : "vazio";
          const isSel = selected === ds;
          return (
            <button key={ds} type="button" data-testid={`cal-day-${ds}`} title={state}
              disabled={state === "bloqueado" || state === "vazio" || !onSelect}
              onClick={() => onSelect?.(ds)}
              className={`h-8 rounded-md text-xs transition-colors duration-150 ${STATE_CLS[state] || STATE_CLS.vazio} ${isSel ? "ring-2 ring-indigo-500" : ""}`}>
              {d}
            </button>
          );
        })}
      </div>
      <div className="flex items-center gap-3 mt-2 text-[10px] text-zinc-500">
        <span className="flex items-center gap-1"><span className="h-2 w-2 rounded-sm bg-emerald-400/40" /> Livre</span>
        <span className="flex items-center gap-1"><span className="h-2 w-2 rounded-sm bg-amber-400/40" /> Com reserva</span>
        <span className="flex items-center gap-1"><span className="h-2 w-2 rounded-sm bg-zinc-600" /> Bloqueado</span>
      </div>
    </div>
  );
}
